import { AfterViewInit, Injectable, OnDestroy } from "@angular/core";
import { set as _set } from "lodash";
import { BehaviorSubject ,  Subscription } from "rxjs";
import { NSFormFields } from "../../../../types";
import { FieldStateService } from "../../field-state.service";

@Injectable()
export class MultiselectStateService extends FieldStateService implements AfterViewInit, OnDestroy {
    public stateObservable$: BehaviorSubject<any>;
    public stateSubscriber$: Subscription;
    public fieldOptions: NSFormFields.IOptionsState[];
    public selectedValue: string[] = [];
    public selectedLabel: string;

    constructor() {
        super();
    }

    public ngAfterViewInit() {
        this.stateSubscriber$ = this.stateObservable$.subscribe((state) => {
            this.fieldOptions = state.options;
            this.selectedValue = state.selectedValue || this.selectedValue;
            this.selectedLabel = state.selectedLabel || this.selectedLabel;
        });
    }

    public ngOnDestroy() {
        this.stateSubscriber$.unsubscribe();
    }

    public transformAndDispatchFieldUpdate(payload) {
        if (payload != null) {
            if (this.selectedValue.some((x) => x === payload)) {
                this.selectedValue = this.selectedValue.filter((x) => x !== payload);
            } else {
                this.selectedValue = [...this.selectedValue, payload];
            }
            const toggledKeys = this.selectedValue.sort();
            this.dispatchFieldUpdate(toggledKeys);
        }
    }

    public dispatchFieldUpdate(toggledKeys) {
        if (toggledKeys != null) {
            const newState = super.newState({ selectedValue: toggledKeys, value: toggledKeys });
            const firstLabel = toggledKeys[0];
            const additionalLabels = toggledKeys.slice(1);
            if (additionalLabels.length && firstLabel != null) {
                _set(newState, "selectedLabel", `${firstLabel}+${additionalLabels.length}`);
            } else if (firstLabel != null) {
                _set(newState, "selectedLabel", `${firstLabel}`);
            } else {
                _set(newState, "selectedLabel", "");
            }
            this.selectedLabel = newState.selectedLabel;
            this.selectedValue = newState.selectedValue;
            this.stateObservable$.next(newState);
        }
    }

    public dispatchFieldLoad(payload): void {
        this.dispatchFieldUpdate(payload);
    }

    public dispatchListLoad(payload, ...args): void {
        const fieldOptionsLabelPath = args[0];
        const fieldOptionsIdPath = args[1];
        const options = payload.map((option) => {
            return {
                label: option[fieldOptionsLabelPath] || option.label,
                value: option[fieldOptionsIdPath] || option.value,
                state: undefined,
            };
        });
        this.stateObservable$.next(super.newState({ options }));
    }

    public dispatchStateReset(initialState): void {
        const options = this.fieldOptions;
        this.stateObservable$.next(super.newState({ options }));
    }
}
